import React, {Component} from 'react'
import PropTypes from 'prop-types';

import './list.styl'

class PageList extends Component {
     static propTypes = {
        className: PropTypes.string,
        filter: PropTypes.object,
        list: PropTypes.object,
        pagify: PropTypes.object
    }

    static defaultProps = {
        className: false
    }

    render() {
        const {className=false, filter= <div/>, list= <div/>, pagify= <div/>} =  this.props;

        return (<div className={'pageList' + (className ? ' ' + className : '')}>
            <div className="pageList-filter">
                {filter}
            </div>
            <div className="pageList-result">
                {list}
            </div>
            <div className="pageList-pagify">
                {pagify}
            </div>
        </div>)
    }
}

export default PageList;
